module.exports = __webpack_public_path__ + "img/11166_SEAGREEN.0f41e955.webp";